module.exports = __webpack_public_path__ + "media/images/done-1abd603c802cc82590c44fd7c22a48a0.svg";